import React, { Component } from 'react';
import { _Queue, _AgentQueueHistory, _UserDetails, _conversationHistory } from './models';
import personIcon from '../assets/icons/person.svg';
import emailIcon from '../assets/icons/email.svg';
import phoneIcon from '../assets/icons/phone.svg';
import upArrow from '../assets/icons/up_arrow.svg';
import downArrow from '../assets/icons/down_arrow.svg';
import startedChatIcon from '../assets/icons/msg_unfilled.svg';
import transferedChatIcon from '../assets/icons/transfered.svg';
import handoffChatIcon from '../assets/icons/flag.svg';
import { parseJSON, decodeHTMLTags } from '../utils/index';
import Whatsapp_channel from '../assets/icons/whatsapp_channel.png';
import Webs_channel from '../assets/icons/webs_channel.svg';

type Props = {
  custID: string;
  userDetails: _UserDetails[];
  actionHistory: _AgentQueueHistory[];
  conversationHistory: _conversationHistory[];
};
type State = {
  dataHistory: number;
  keyIndex: string;
  hideShowAgentQueueHistory: boolean;
  timestring: string;
  displayElement: string;
};
export default class ConversationHistory extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }
  setInitialState(): State {
    return {
      dataHistory: -1,
      keyIndex: '',
      hideShowAgentQueueHistory: false,
      timestring: '',
      displayElement: 'none',
    };
  }
  hideElem(data: string) {
    var addclass = document.getElementById(`${data}`);
    if (addclass) {
      if (addclass.style.display === 'block' || addclass.style.display === '') {
        addclass.style.display = 'none';
        this.setState({
          hideShowAgentQueueHistory: false,
        });
      } else {
        this.setState({
          hideShowAgentQueueHistory: true,
        });
        addclass.style.display = 'block';
      }
    }
  }
  getDividerFormatDate = (date: any) => {
    var newDate, todayDate, yesterdayDate, finalDate;
    newDate = date;
    var today = new Date();
    var currentDate = today.getDate();
    var currentMonth = today.getMonth();
    // var today = new Date(),
    //   todayDate,
    //   yesterdayDate,
    //   finalDate;
    // var currentMonth = today.getMonth();
    // if (currentMonth >= 9) {
    //   todayDate =
    //     today.getFullYear() + "-" + currentMonth + "-" + today.getDate();
    //   yesterdayDate =
    //     today.getFullYear() + "-" + currentMonth + "-" + (today.getDate() - 1);
    // } else {
    //   todayDate =
    //     today.getFullYear() + "-0" + (currentMonth + 1) + "-" + today.getDate();
    //   yesterdayDate =
    //     today.getFullYear() +
    //     "-0" +
    //     (currentMonth + 1) +
    //     "-" +
    //     (today.getDate() - 1);
    // }
    if (currentMonth >= 9) {
      if (currentDate >= 9) {
        todayDate = today.getFullYear() + '-' + currentMonth + '-' + currentDate;
        yesterdayDate =
          today.getFullYear() + '-' + currentMonth + '-' + (currentDate - 1);
      } else {
        todayDate =
          today.getFullYear() + '-' + (currentMonth + 1) + '-' + '0' + currentDate;
        yesterdayDate =
          today.getFullYear() + '-' + (currentMonth + 1) + '-' + '0' + (currentDate - 1);
        // console.log(todayDate)
      }
    } else {
      if (currentDate > 9) {
        todayDate = today.getFullYear() + '-0' + (currentMonth + 1) + '-' + currentDate;
        yesterdayDate =
          today.getFullYear() + '-0' + (currentMonth + 1) + '-' + (currentDate - 1);
      } else {
        todayDate = today.getFullYear() + '-0' + (currentMonth + 1) + '-0' + currentDate;
        yesterdayDate =
          today.getFullYear() + '-0' + (currentMonth + 1) + '-0' + (currentDate - 1);
      }
    }
    if (newDate == todayDate) {
      finalDate = 'Today';
    } else if (newDate == yesterdayDate) {
      finalDate = 'Yesterday';
    } else {
      const wholeDate = newDate.split('-');
      var mlist = [
        'Jan',
        'Feb',
        'Mar',
        'April',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      // if (wholeDate[1] < 9) {
      var month = wholeDate[1];
      // } else {
      //   var month = wholeDate[1][1];
      // }

      finalDate = mlist[month - 1] + ' ' + wholeDate[2] + ', ' + wholeDate[0];
    }
    return finalDate;
  };
  render() {
    return (
      <div className='conversation-history-container'>
        <div className='sub-conv-history-container'>
          <div className='section-1'>
            <div>
              <div className='session-start-time'>Session start time</div>
              {this.props.userDetails.length !== 0 && (
                <div className='time'>{this.props.userDetails[0].session_start_time}</div>
              )}
            </div>
            <div>
              <div
                style={{
                  lineHeight: '1.8',
                  fontSize: '10px',
                  fontWeight: 600,
                  color: '#6c7ef2',
                  textTransform: 'uppercase',
                  marginTop: '12px',
                }}>
                User details
              </div>

              {this.props.userDetails.length !== 0 && (
                <div
                  style={{
                    fontSize: '14px',
                    color: 'rgba(0, 0, 0, 0.8)',
                    lineHeight: 1.29,
                  }}>
                  {this.props.userDetails[0].name !== 'null' &&
                    this.props.userDetails[0].name !== '' && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={personIcon}
                          alt='personIcon'
                          style={{ width: '18px', height: '18px' }}
                        />
                        <span style={{ marginLeft: '8px' }}>
                          {this.props.userDetails[0].name === 'null'
                            ? '-'
                            : this.props.userDetails[0].name}
                        </span>
                      </div>
                    )}
                  {this.props.userDetails[0].email !== 'null' &&
                    this.props.userDetails[0].email !== '' && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={emailIcon}
                          alt='emailIcon'
                          style={{ width: '18px', height: '18px' }}
                        />
                        <span style={{ marginLeft: '8px' }}>
                          {this.props.userDetails[0].email}
                        </span>
                      </div>
                    )}
                  {this.props.userDetails[0].contact_no !== 'null' &&
                    this.props.userDetails[0].contact_no !== '' && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={phoneIcon}
                          alt='phoneIcon'
                          style={{ width: '18px', height: '18px' }}
                        />
                        <span style={{ marginLeft: '8px' }}>
                          {this.props.userDetails[0].contact_no}
                        </span>
                      </div>
                    )}
                </div>
              )}
            </div>
            <div
              style={{
                marginTop: '12px',
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '15px',
              }}>
              <span
                style={{
                  lineHeight: '1.8',
                  fontSize: '10px',
                  fontWeight: 600,
                  color: '#6c7ef2',
                }}>
                SOURCE
              </span>

              {this.props.userDetails.length !== 0 && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '3px',
                  }}>
                  <img
                    src={
                      this.props.userDetails[0].channel === 'webs'
                        ? Webs_channel
                        : this.props.userDetails[0].channel === 'whatsapp' ||
                          this.props.userDetails[0].channel === 'WhatsApp'
                        ? Whatsapp_channel
                        : ''
                    }
                    alt=''
                    style={{ width: '18px', height: '18px' }}
                  />
                  <span
                    style={{
                      fontSize: '12px',
                      lineHeight: '1.29',
                      color: 'rgba(0, 0, 0, 0.8)',
                      marginLeft: '8px',
                    }}>
                    {/* {this.props.userDetails[0].channel} */}
                    {this.props.userDetails[0].channel === 'webs' &&
                    (this.props.userDetails[0].deviceInfo === null ||
                      this.props.userDetails[0].deviceInfo === undefined ||
                      this.props.userDetails[0].deviceInfo === '')
                      ? 'Web'
                      : this.props.userDetails[0].channel === 'webs'
                      ? //  `Web (${this.props.userDetails[0].deviceInfo})` :
                        `Web ${
                          this.props.userDetails[0].deviceInfo !== null ||
                          this.props.userDetails[0].deviceInfo !== undefined
                            ? '(' + this.props.userDetails[0].deviceInfo + ')'
                            : ''
                        }`
                      : this.props.userDetails[0].channel === 'whatsapp'
                      ? 'WhatsApp'
                      : this.props.userDetails[0].channel}
                  </span>
                </div>
              )}
            </div>
            <div
              style={{
                marginTop: '12px',
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '15px',
              }}>
              <span
                style={{
                  lineHeight: '1.8',
                  fontSize: '10px',
                  fontWeight: 600,
                  color: '#6c7ef2',
                }}>
                LANGUAGE
              </span>
              <span
                style={{
                  fontSize: '14px',
                  lineHeight: '1.29',
                  color: 'rgba(0, 0, 0, 0.8)',
                }}>
                English
              </span>
            </div>
          </div>

          {this.props.actionHistory.length !== 0 && (
            <div
              style={{
                fontSize: '14px',
                fontWeight: 600,
                display: 'flex',
                justifyContent: 'flex-start',
                marginTop: '10px',
                flexDirection: 'column',
                height: 'calc(75vh - 166px)',
                overflowY: 'auto',
                color: 'rgba(0, 0, 0, 0.8)',
              }}>
              {this.props.actionHistory.map((history, index) => {
                var trigger_time = new Date(history.handoff_trigger_time);
                var trigger_timeString = trigger_time.toLocaleString([], {
                  hour: 'numeric',
                  minute: '2-digit',
                  second: '2-digit',
                  // hour12: true,
                });
                // var trigger_timeString='0:0'
                //  var trigger_timeString=history.handoff_trigger_time
                return (
                  <div key={index}>
                    <div
                      className='clickable'
                      onClick={() => {
                        this.setState((PrevState) => ({
                          timestring: trigger_timeString,
                          dataHistory: index,
                          displayElement:
                            PrevState.displayElement === `block${index}`
                              ? `none${index}`
                              : `block${index}`,
                        }));
                      }}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '10px',
                      }}>
                      <span style={{ fontSize: '14px', lineHeight: '1.13' }}>
                        <span style={{ textTransform: 'uppercase' }}>
                          {trigger_timeString}
                        </span>{' '}
                        {history.handoff_trigger}
                      </span>
                      <span>
                        <img
                          src={
                            this.state.timestring === trigger_timeString &&
                            this.state.dataHistory === index &&
                            this.state.displayElement === `block${index}`
                              ? upArrow
                              : downArrow
                          }
                          alt='arrow'
                        />
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {history.status !== '-' && (
                        <span
                          style={{
                            border: 'none',
                            borderRadius: '5px',
                            backgroundColor: 'rgba(255, 0, 0, 0.2)',
                            padding: '4px',
                            fontSize: '10px',
                            lineHeight: '0.8',
                            fontWeight: 600,
                          }}>
                          {history.status}
                        </span>
                      )}
                      {history.userFeedback !== '-' && (
                        <span
                          style={
                            history.userFeedback === 'POSITIVE'
                              ? {
                                  fontSize: '10px',
                                  color: '#009f17',
                                  marginLeft: '10px',
                                }
                              : {
                                  fontSize: '10px',
                                  color: '#ff0000',
                                  marginLeft: '10px',
                                }
                          }>
                          {history.userFeedback}
                        </span>
                      )}
                    </div>
                    {history.userComment !== '-' && (
                      <div style={{ marginTop: '20px', fontSize: '14px' }}>
                        <span style={{ fontWeight: 'bold' }}>User Comment:</span>
                        <span
                          style={{
                            fontSize: '13px',
                            lineHeight: '1.57',
                            marginLeft: '3px',
                          }}>
                          {history.userComment}
                        </span>
                      </div>
                    )}
                    {this.state.timestring === trigger_timeString &&
                      this.state.dataHistory === index &&
                      this.state.displayElement === `block${index}` && (
                        <div id={history.handoff_trigger}>
                          {
                            <div
                              style={{
                                lineHeight: ' 1.8',
                                letterSpacing: '0.15px',
                                textTransform: 'uppercase',
                                marginTop: '20px',
                                fontSize: '10px',
                                fontWeight: 600,
                              }}>
                              Agent & Queue history
                            </div>
                          }

                          {history.actionList.map((actionmsg: any, index: number) => {
                            var date = new Date(actionmsg.time);
                            // var timeString = date.toLocaleString([], {
                            //   hour: "numeric",
                            //   minute: "2-digit",
                            //   hour12: true,
                            // });
                            var timeString = actionmsg.time;
                            return (
                              <div id={`${index}`} style={{ marginTop: '10px' }}>
                                <div
                                  style={{
                                    fontWeight: 500,
                                  }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}>
                                    <img
                                      src={
                                        actionmsg.action === 'Started'
                                          ? startedChatIcon
                                          : actionmsg.action === 'Transfered'
                                          ? transferedChatIcon
                                          : actionmsg.action === 'pending' ||
                                            actionmsg.action === 'user_left' ||
                                            actionmsg.action === 'Closed'
                                          ? handoffChatIcon
                                          : ''
                                      }
                                      style={{
                                        width: '15px',
                                        height: '15px',
                                      }}
                                      alt='actionmsg'
                                    />
                                    <div style={{ marginRight: '10px' }}>
                                      {actionmsg.msg}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      marginTop: ' -15px',
                                      paddingRight: '20px',
                                      textTransform: 'uppercase',
                                    }}>
                                    {timeString}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {this.props.conversationHistory.length !== 0 && (
          <div
            style={{
              padding: '10px',
              overflowY: 'auto',
              width: '40%',
              marginTop: '5px',
            }}>
            {this.props.conversationHistory.map((convHis, index) => {
              var date = new Date(convHis.time);
              var hour = date.getHours();
              var min: any = date.getMinutes();
              var amPm, displayHour;
              if (hour >= 12) {
                displayHour = hour % 12;
                displayHour = displayHour ? displayHour : 12;
                amPm = 'PM';
              } else {
                displayHour = hour;
                amPm = 'AM';
              }
              if (min < 10) {
                min = `0${min}`;
              }
              var timeString = `${displayHour}:${min} ${amPm}`;
              // var timeString = date.toLocaleString([], {
              // hour: "numeric",
              // minute: "2-digit",
              // hour12: true,
              // });

              let historyName = convHis.message.split(' ');
              let msg = convHis.message;
              let disamb = convHis.disambQuestions;
              let showdate = convHis.date;

              if (convHis.message.indexOf('<p>#SF#</p>') > -1) {
                msg = parseJSON(msg.replace('<p>#SF#</p>', ''));
              }

              return (
                <div key={index}>
                  {showdate &&
                  showdate !== undefined &&
                  showdate !== null &&
                  showdate !== '-' ? (
                    <div className='sf-date-divider-capsule-w'>
                      <div>{this.getDividerFormatDate(showdate)}</div>
                    </div>
                  ) : null}
                  {convHis.message !== '-' &&
                  convHis.message !== undefined &&
                  convHis.message !== null ? (
                    <div
                      className={`${
                        (convHis.source === 'agent' &&
                          convHis.message === 'Connected with user') ||
                        convHis.message === 'User has left the chat' ||
                        convHis.message === 'Disconnected from user' ||
                        convHis.message === 'Chat has been transferred' ||
                        convHis.message === 'Chat has been released' ||
                        convHis.message === 'Disconnected from agent' ||
                        convHis.message === 'Agent released the chat' ||
                        convHis.message.indexOf('Agent Transfer the chat to') > -1 ||
                        convHis.message ===
                          'You Taken over a conversation with the Chat bot' ||
                        convHis.message.indexOf('Agent started a conversation with') >
                          -1 ||
                        convHis.message === 'Agent has ended the chat' ||
                        convHis.message === 'Transferred as the agent exit from screen' ||
                        convHis.message === 'Customer disconnected from the chat'
                          ? 'connected message capsule'
                          : convHis.source === 'agent'
                          ? 'agent-msg message'
                          : 'user-msg message '
                      }`}>
                      <div
                        style={{
                          display:
                            convHis.agentid === '0_B' ||
                            convHis.message ===
                              'Your chat has been transferred. Please stay online while the other agent connects with you' ||
                            convHis.message ===
                              'Your chat has been released. Please stay online while the other agent connects with you'
                              ? 'inline-block'
                              : '',
                        }}
                        className={`${
                          convHis.message === 'Connected with user' ||
                          convHis.message === 'User has left the chat' ||
                          convHis.message === 'Disconnected from user' ||
                          convHis.message === 'Chat has been transferred' ||
                          convHis.message === 'Chat has been released' ||
                          convHis.message === 'Disconnected from agent' ||
                          convHis.message === 'Agent released the chat' ||
                          convHis.message.indexOf('Agent Transfer the chat to') > -1 ||
                          convHis.message ===
                            'You Taken over a conversation with the Chat bot' ||
                          convHis.message.indexOf('Agent started a conversation with') >
                            -1 ||
                          convHis.message === 'Agent has ended the chat' ||
                          convHis.message ===
                            'Transferred as the agent exit from screen' ||
                          convHis.message === 'Customer disconnected from the chat'
                            ? 'test'
                            : ''
                        } ${
                          convHis.agentid === '0_B' ||
                          convHis.message ===
                            'Your chat has been transferred. Please stay online while the other agent connects with you' ||
                          convHis.message ===
                            'Your chat has been released. Please stay online while the other agent connects with you'
                            ? 'agent-capsule'
                            : ''
                        }`}>
                        <span
                          className={`${
                            convHis.source === 'user' &&
                            convHis.message !== 'User has left the chat' &&
                            convHis.message !== 'Disconnected from user' &&
                            convHis.message !== 'Chat has been transferred' &&
                            convHis.message !== 'Chat has been released' &&
                            convHis.message !== 'Disconnected from agent' &&
                            convHis.message !== 'Agent released the chat' &&
                            convHis.message.indexOf('Agent Transfer the chat to') <= -1 &&
                            convHis.message !==
                              'You Taken over a conversation with the Chat bot' &&
                            convHis.message.indexOf(
                              'Agent started a conversation with'
                            ) <= -1 &&
                            convHis.message !== 'Agent has ended the chat' &&
                            convHis.message !==
                              'Transferred as the agent exit from screen' &&
                            convHis.message !== 'Customer disconnected from the chat'
                              ? 'user-capsule'
                              : convHis.source === 'agent' &&
                                convHis.message !== 'Connected with user' &&
                                convHis.agentid !== '0_B' &&
                                convHis.message !== 'Disconnected from user' &&
                                convHis.message !== 'Chat has been transferred' &&
                                convHis.message !== 'Chat has been released' &&
                                convHis.message !== 'Disconnected from agent' &&
                                convHis.message !== 'Agent released the chat' &&
                                convHis.message.indexOf('Agent Transfer the chat to') <=
                                  -1 &&
                                convHis.message !==
                                  'You Taken over a conversation with the Chat bot' &&
                                convHis.message.indexOf(
                                  'Agent started a conversation with'
                                ) <= -1 &&
                                convHis.message !== 'Agent has ended the chat' &&
                                convHis.message !==
                                  'Transferred as the agent exit from screen' &&
                                convHis.message !==
                                  'Customer disconnected from the chat' &&
                                'Your chat has been transferred. Please stay online while the other agent connects with you'
                              ? 'agent-capsule'
                              : ''
                          }`}>
                          {convHis.message === 'Connected with user' ? (
                            historyName[0] +
                            ' ' +
                            historyName[1] +
                            ' ' +
                            (convHis.agentName !== '-' ? convHis.agentName : 'user')
                          ) : /(<([^>]+)>)/gi.test(convHis.message) ? ( //nosonar
                            <div
                              dangerouslySetInnerHTML={{
                                __html: decodeHTMLTags(msg),
                              }}></div>
                          ) : (
                            convHis.message
                          )}

                          {disamb && disamb !== '-' && JSON.parse(disamb).length > 0
                            ? JSON.parse(disamb).map((eachdisamb: any, index: number) => {
                                return (
                                  <div
                                    className='disamb-action-elem'
                                    key={index}
                                    style={{ pointerEvents: 'none' }}>
                                    {eachdisamb.displayText}
                                  </div>
                                );
                              })
                            : null}
                        </span>
                      </div>
                    </div>
                  ) : null}
                  {convHis.message !== '-' &&
                  convHis.message !== undefined &&
                  convHis.message !== null ? (
                    <div
                      className={`${
                        (convHis.source === 'agent' &&
                          convHis.message === 'Connected with user') ||
                        convHis.message === 'User has left the chat' ||
                        convHis.message === 'Disconnected from user'
                          ? 'display-time time'
                          : convHis.source === 'agent'
                          ? 'agent-msg time'
                          : 'user-msg time'
                      }`}
                      style={{ textTransform: 'uppercase' }}>
                      {timeString}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
